import { Measurements } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { BinIssueStateMixin } from './bin-issue-state-mixin';
import './bin-profile-measurements';
import '../../common/bn-property';
import '../../common/bn-loading';

class BinIssueStateDimensionsQuestion extends BinIssueStateMixin(LitEntity) {
  static get styles() {
    return [super.styles, css`
      .pointer.top-height:hover ~ bin-profile-measurements {
        --bin-profile-measurements-top-opacity: 1;
      }
      .pointer.body-height:hover ~ bin-profile-measurements {
        --bin-profile-measurements-body-opacity: 1;
      }
      .pointer.hopper-height:hover ~ bin-profile-measurements {
        --bin-profile-measurements-hopper-opacity: 1;
      }
      .pointer.ring-count:hover ~ bin-profile-measurements {
        --bin-profile-measurements-ring-opacity: 1;
      }
      .pointer.diameter:hover ~ bin-profile-measurements {
        --bin-profile-measurements-diameter-opacity: 1;
      }
      .grid {
        display: grid;
        grid-template-columns: 1fr .65fr 1fr;
        grid-template-rows: 11vh 11vh 11vh;
        gap: .25em .5em;
      }
      .pointer {
        padding: .25em;
        pointer-events: none;
        display: flex;
      }
      .pointer .inner {
        box-sizing: border-box;
        border: 2px solid var(--gray-10);
        pointer-events: all;
        max-height: 55px;
        display: flex;
        align-items: center;
        background-color: var(--gray-10);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.35);
        padding: .5em .5em .5em .75em;
        max-width: 75%;
        transition: background-color .2s, transform .2s, border-color .2s, box-shadow .2s;
      }
      .pointer .inner:hover {
        background-color: var(--hover-color);
        transform: translateY(-2px);
        border-color: var(--blue-60);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.25);
      }
      @media(max-width: 800px) {
        .pointer .inner {
          max-width: 100%;
        }
      }
      .left {
        grid-column: 1;
        justify-content: flex-end;
      }
      .left .inner {
        justify-content: flex-end;
        border-radius: 0 20px 20px 0;
      }
      .right {
        grid-column: 3;
      }
      .right .inner {
        border-radius: 20px 0 0 20px;
      }
      .ring-count {
        grid-row: 2;
      }
      .diameter {
        grid-row: 3;
      }
      .top-height {
        grid-row: 1;
      }
      bin-profile-measurements {
        height: 33vh;
        max-height: 400px;
        width: 100%;
        grid-row: 1 / 3;
        grid-column: 2;
        --bin-profile-measurement-colour: var(--blue-60);
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`<bn-loading></bn-loading>`;
    }

    const dimension = Measurements.get('dimension');
    const { top, body, hopper, ringCount } = this.getProperty('dimensions');
    return html`
      <h2>Do the measurements of this bin look correct?</h2>
      <div class="grid">
        <div class="pointer ring-count left">
          <div class="inner">
            <bn-property stacked label="Ring Count">
              ${ringCount}
            </bn-property>
          </div>
        </div>
        <div class="pointer diameter left">
          <div class="inner">
            <bn-property stacked label="Diameter">
              ${dimension.html({ dimension: body.radius * 2 })}
            </bn-property>
          </div>
        </div>
        <div class="pointer top-height right">
          <div class="inner">
            <bn-property stacked label="Top Height">
              ${dimension.html({ dimension: top.height })}
            </bn-property>
          </div>
        </div>
        <div class="pointer body-height right">
          <div class="inner">
            <bn-property stacked label="Body Height">
              ${dimension.html({ dimension: body.height })}
            </bn-property>
          </div>
        </div>
        <div class="pointer hopper-height right">
          <div class="inner">
            <bn-property stacked label="Hopper Height">
              ${dimension.html({ dimension: hopper.height })}
            </bn-property>
          </div>
        </div>
        <bin-profile-measurements .href="${this.href}"></bin-profile-measurements>
      </div>
      ${this.renderYesNo()}
    `;
  }
}

window.customElements.define('bin-issue-state-dimensions-question', BinIssueStateDimensionsQuestion);
